import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
// @ts-ignore
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import MezzoLightsSettings from '@app/components/MyDevices/MyMezzo/MezzoLightsSettings/MezzoLightsSettings'
import {
  withAccessDenied, withNotifications, withProgressAndErrorMessage, withRefresh,
} from '@app/hocs'
import { syncMezzoLights } from '@app/actions/myDevices/mezzoLights'
import { AppState } from '@app/@types/store'
import { AppDispatch } from '@app/store'

let enhance = MezzoLightsSettings

const mapStateToProps = (state: AppState) => {
  const { mezzoLights } = state.myDevices.myDevices
  const { isMobile } = state.mobileDetector
  return {
    mezzoLights,
    isMobile,
    accessToken: state.secrets.accessToken && state.secrets.accessToken.token,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
  }
}

const mapDispatchToProps = (dispatch: AppDispatch) => bindActionCreators({
  refresh: syncMezzoLights,
  tryAgain: syncMezzoLights,
  notifications: syncNotifications.sync,
}, dispatch)

enhance = withRefresh(enhance)
enhance = withNotifications(enhance)
enhance = withProgressAndErrorMessage(enhance)
enhance = withAccessDenied(enhance)
// @ts-ignore
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const MezzoLightsSettingsEnhanced = enhance

export default MezzoLightsSettingsEnhanced
